import * as Yup from "yup";

const ADD_CURRENCY_VALIDATION = Yup.object({
  currencyName: Yup.string().required().label("Name"),
  currencyValue: Yup.number().required().label("Rate"),
});

export { ADD_CURRENCY_VALIDATION };
